const clearFormButton = (button) => {
  button.addEventListener("click", () => {
    const form = button.closest("form");
    if (!form) return;

    form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.checked = false;
    });
  });
};
